module.exports = __webpack_public_path__ + "img/add_btn_icon220.9b2cd583.svg";